import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { deleteCallGroup, getListCallGroup } from "entities/course/service";

const DeleteConfirmation = ({
  openDeleteConfirm,
  setOpenDeleteConfirm,
  getIdClass,
  setCallGroup,
  getDetailCourse,
  setSnackbarMessage,
  setSnackbarSeverity,
  setSnackbarOpen,
}) => {
  const handleClose = () => {
    setOpenDeleteConfirm(false);
  };

  //   const handleConfirmDelete = () => {
  //     onDelete();
  //     setOpen(false);
  //   };

  const handleSubmit = async () => {
    try {
      await deleteCallGroup(getIdClass);
      console.log("Xóa thành công");
      setOpenDeleteConfirm(false);

      const data = await getListCallGroup(getDetailCourse._id);
      setCallGroup(data.data);
      setSnackbarMessage(`Xóa thành công!`);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Failed to delete redeem", error);
      setSnackbarMessage(`Xóa thất bại, xin vui lòng thử lại!`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Dialog
        open={openDeleteConfirm}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Bạn chắc chắn muốn xóa phần này?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Hành động này không thể hoàn tác. Bạn có chắc chắn muốn xóa phần này
            không?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Hủy
          </Button>
          <Button onClick={handleSubmit} color="primary" autoFocus>
            Xóa
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteConfirmation;
